import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PopupSignalService {

  private _popupVisible = signal<boolean>(false);

  popupVisible() {
    return this._popupVisible();
  }

  showPopup() {
    console.log('show');
    this._popupVisible.set(true);
  }

  hidePopup() {
    console.log('hide');
    this._popupVisible.set(false);
  }
  
  constructor() { }
}
